// extracted by mini-css-extract-plugin
module.exports = {"page-message":"page-message___Ak7wD"};